import Vue from 'vue'

export default {
	'RESUME': async (context) => {
		return await Vue.http.get(`${process.env.VUE_APP_API_URL}/resume`)
			.then(
				res => {
					context.commit('DATA_RESUME', res.body);
					context.commit('AUTH', true);
					return res;
				},
				err => {
					console.log(err);
					context.commit('AUTH', false);
				}
			)
			.catch(err => console.error(`catch, ${err}`));
	},

	'UPDATE_RESUME_DATA': async (context, data) => {
		return await Vue.http.post(`${process.env.VUE_APP_API_URL}/resume/update`, data)
			.then(
				res => {
					context.commit('DATA_RESUME', data);
					return res;
				},
				err => {
					return err;
				}
			)
			.catch(err => console.error(`catch, ${err}`));
	},
};
